import { MenuItem } from 'primeng/api';

export type SplitButtonItem = MenuItem;
